import React from "react";

const AllSkills = () => {

  window.scrollTo(0, 0);
  return (
    <div
      id="#skill"
      className="px-3 md:px-10 lg:px-20   content  max-w-[1400px] mx-auto"
    >
      <div className="text-center pt-20">
        <h1
          data-aos="fade-zoom-in"
          data-aos-easing="ease-in-back"
          data-aos-delay="300"
          data-aos-offset="0"
          className="text-[80px] tracking-[7px] md:text-[130px]  font-extrabold   text-gray-500  text-opacity-20 "
        >
          SKILLS
        </h1>
        <h3 className="text-[35px] md:text-[40px] relative font-semibold text-white -mt-[88px] md:-mt-32">
          What I Know
        </h3>
        <div class="flex -mt-2 justify-center">
          <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
        </div>
      </div>

      {/* Expertise--------------------------------------------------------------------------------------------*/}
      
      <div className="py-5 pt-24">
        <h2 className="text-3xl font-semibold text-white">Expertise 👨‍💻</h2>

        {/* skills  */}
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 py-5 text-white">
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transition">
            <img
              class="w-9 rounded-full"
              src="https://w7.pngwing.com/pngs/201/90/png-transparent-logo-html-html5.png"
              alt=""
            />
            <div>
              <span>HTML</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://w7.pngwing.com/pngs/696/424/png-transparent-logo-css-css3-thumbnail.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>CSS</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://e7.pngegg.com/pngimages/439/345/png-clipart-bootstrap-logo-thumbnail-tech-companies.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Bootstrap</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSk03fpMxbjzvgaDz2z3gu5G-9UeqgnNfUdd7gzSo9-er843XxKIG3g46lO1GRUF-L9UWs&usqp=CAU"
              alt="img"
              class=" w-9 rounded-full"
            />
            <div>
              <span>Tailwind</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://imagedelivery.net/5MYSbk45M80qAwecrlKzdQ/38a9cafe-c53e-47f2-f431-428120462000/public"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Javascript</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://p7.hiclipart.com/preview/1021/477/199/react-native-javascript-mobile-app-development-github.jpg"
              alt="img"
              class=" w-9 rounded-full"
            />
            <div>
              <span>React</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://images.opencollective.com/daisyui/d1eb928/logo/256.png"
              alt="img"
              class=" w-9 rounded-full"
            />
            <div>
              <span>DaisyUi</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-3 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://tecdn.b-cdn.net/img/logo/te-transparent-noshadows.webp"
              alt="img"
              class=" w-9 bg-gray-300 rounded-full"
            />
            <div>
              <span>TW Elements</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>
        </div>
      </div>

      {/* Comfortable--------------------------------------------------------------------------------------------*/}

      <div className="py-5">
        <h2 className="text-3xl font-semibold text-white">Comfortable 😌</h2>

        {/* skills  */}
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 py-5 text-white">
          {/* <!-- Block 1 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://play-lh.googleusercontent.com/GhQVJ0wdeWzNz1k5jlb8mKNAY4qLgoF0MB8m_Oxor9KSYmq-Q4ShP43I8HLL01BVRIGT"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>NodeJs</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>

          {/* <!-- Block 2 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>ExpressJs</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>

          {/* <!-- Block 3 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://ih1.redbubble.net/image.438910675.6211/st,small,507x507-pad,600x600,f8f8f8.u2.jpg"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>MongoDB</span>
              <span class="text-xs text-blue-300 block">Database</span>
            </div>
          </div>

          {/* <!-- Block 4 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://cdn.icon-icons.com/icons2/691/PNG/512/google_firebase_icon-icons.com_61474.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Firebase</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>

          {/* <!-- Block 5 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://seeklogo.com/images/J/json-web-tokens-jwt-io-logo-C003DEC47A-seeklogo.com.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>JWT</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>

          {/* <!-- Block 6 --> */}
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://icon2.cleanpng.com/20180420/oaw/kisspng-computer-icons-application-programming-interface-r-5ad9d0cf31b7c7.5676330415242242072037.jpg"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Rest Api</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>
        </div>
      </div>

      {/* Familiar--------------------------------------------------------------------------------------------*/}

      <div className="py-5">
        <h2 className="text-3xl font-semibold text-white">Familiar 🤝 </h2>

        {/* skills  */}
        <div class=" grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  py-5  xl:grid-cols-6 text-white gap-2 ">
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://static-00.iconduck.com/assets.00/stripe-icon-256x256-vv7nxk1m.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Stripe</span>
              <span class="text-xs text-blue-300 block">Gateway</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://cdn.icon-icons.com/icons2/2699/PNG/512/wordpress_tile_logo_icon_168757.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Wordpress</span>
              <span class="text-xs text-blue-300 block">CMS</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://cdn.iconscout.com/icon/free/png-256/free-elementor-3628750-3029975.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Elementor</span>
              <span class="text-xs text-blue-300 block">Plugin</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://e7.pngegg.com/pngimages/669/447/png-clipart-redux-react-javascript-freecodecamp-npm-others-miscellaneous-purple-thumbnail.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Redux</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://play-lh.googleusercontent.com/cyTI43JCjc4L-e1m7FvJhI1VhmTSJ4AMNZoqhkp0Xm6_NOtHbaewp9UPVLw5R3-tZIU"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>PHP</span>
              <span class="text-xs text-blue-300 block">Backend</span>
            </div>
          </div>
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQoFkPtG7UYbp26LxSxBt5xg6WIiPQzqz6HnlxZIUeVGVXcD7h5KFyPkcykcwM0TtzUhkk&usqp=CAU"
              alt="img"
              class=" w-9 rounded-full"
            />
            <div>
              <span>Jquery</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://i1.wp.com/www.ux-republic.com/wp-content/uploads/2018/03/socket.png?fit=375%2C375&ssl=1"
              alt="img"
              class=" w-9"
            />
            <div>
              <span>Socket.io</span>
              <span class="text-xs text-blue-300 block">Frontend</span>
            </div>
          </div>
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://www.freepnglogos.com/uploads/logo-mysql-png/logo-mysql-mysql-logo-png-images-are-download-crazypng-21.png"
              alt="img"
              class=" w-9"
            />
            <div>
              <span>MySql</span>
              <span class="text-xs text-blue-300 block">Database</span>
            </div>
          </div>
        </div>
      </div>

      {/*Tools --------------------------------------------------------------------------------------------*/}

      <div className="py-5 pb-6">
        <h2 className="text-3xl font-semibold text-white">Tools 🧰 </h2>

        {/* skills  */}
        <div class=" grid grid-cols-2 md:grid-cols-4  py-5 lg:grid-cols-6 text-white gap-2 ">
          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://cdn.sanity.io/images/599r6htc/localized/46a76c802176eb17b04e12108de7e7e0f3736dc6-1024x1024.png?w=804&h=804&q=75&fit=max&auto=format"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Figma</span>
              <span class="text-xs text-blue-300 block">Design</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Git Hub</span>
              <span class="text-xs text-blue-300 block">Hosting</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://cdn.shopify.com/s/files/1/0332/2730/9195/products/Monogram-Sticker.png?v=1678930262"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>Netlify</span>
              <span class="text-xs text-blue-300 block">Hosting</span>
            </div>
          </div>

          <div data-aos="flip-left" data-aos-duration="1400" class="group flex items-center justify-center bg-gray-500  md:bg-gray-600 md:bg-opacity-25 bg-opacity-40 shadow-xl gap-4 p-4 rounded-md cursor-pointer hover:bg-gray-400 hover:bg-opacity-30 transitio">
            <img
              src="https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png"
              alt="img"
              class="w-9 rounded-full"
            />
            <div>
              <span>vercel</span>
              <span class="text-xs text-blue-300 block">Hosting</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllSkills;
